import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { formatPrice, calculateSavingsPercent } from '../../lib/utils';

export default function LookCard({ look, index = 0 }) {
  const savingsPercent = calculateSavingsPercent(
    look.original_price_cents, 
    look.bundle_price_cents
  );

  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="group"
    >
      <Link 
        to={`/looks/${look.slug}`} 
        className="block"
        data-testid={`look-card-${look.slug}`}
      >
        {/* Image */}
        <div className="relative aspect-[3/4] overflow-hidden bg-muted">
          <img
            src={look.images?.[0] || 'https://images.unsplash.com/photo-1652281846260-14c1bdd5e9a0?w=800'}
            alt={look.name}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          
          {/* Savings Badge */}
          {savingsPercent > 0 && (
            <div className="absolute top-4 left-4 bg-foreground text-background px-3 py-1 text-xs font-medium">
              -{savingsPercent}%
            </div>
          )}

          {/* Quick View Overlay */}
          <div className="absolute inset-0 bg-foreground/0 group-hover:bg-foreground/10 transition-colors duration-300 flex items-end justify-center pb-8 opacity-0 group-hover:opacity-100">
            <span className="bg-background text-foreground px-6 py-2 text-sm font-medium transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
              Voir le look
            </span>
          </div>
        </div>

        {/* Info */}
        <div className="mt-4 space-y-2">
          {/* Style & Occasion Tags */}
          <div className="flex gap-2">
            {look.style && (
              <span className="text-xs text-muted-foreground uppercase tracking-wider">
                {look.style}
              </span>
            )}
            {look.occasion && (
              <>
                <span className="text-muted-foreground/50">•</span>
                <span className="text-xs text-muted-foreground uppercase tracking-wider">
                  {look.occasion}
                </span>
              </>
            )}
          </div>

          {/* Name */}
          <h3 className="font-display text-xl font-medium group-hover:underline underline-offset-4 decoration-1">
            {look.name}
          </h3>

          {/* Prices */}
          <div className="flex items-baseline gap-3">
            <span className="text-lg font-medium">
              {formatPrice(look.bundle_price_cents)}
            </span>
            {look.original_price_cents > look.bundle_price_cents && (
              <span className="text-sm text-muted-foreground line-through">
                {formatPrice(look.original_price_cents)}
              </span>
            )}
          </div>

          {/* Items count */}
          <p className="text-sm text-muted-foreground">
            {look.items?.length || 0} articles inclus
          </p>
        </div>
      </Link>
    </motion.article>
  );
}
